import moment from 'moment';


const dateFormatString = 'D-M-YYYY';

export function formatDate(date) {
	return moment(date).format(dateFormatString);
}
